import React from 'react';
import './LinearGradient.css';

const LinearGradient = (props) => {
  return <div className='linear-gradient'>{props.children}</div>;
};

export default LinearGradient;
